import React from "react";
import "./footer.css";
import company_logo from "../../../../assets/with_background_logo.png"; // Replace with your actual logo

function Footer() {
  return (
    <footer className="footer">
    {/* Decorative Wave Top */}
    <div className="footer-wave">
      <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path d="M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z" fill="white" />
      </svg>
    </div>

    {/* Main Footer */}
    <div className="footer-container">
      {/* Brand + Description */}
      <div className="footer-col">
        <img src={company_logo} alt="MediQNow Logo" className="footer-logo" />
        <p className="footer-desc">
          Your instant healthcare gateway. From urgent bookings to doorstep meds — all at your fingertips.
        </p>
      </div>

      {/* Navigation */}
      <div className="footer-col">
        <h4>Explore</h4>
        <ul>
          <li>Home</li>
          <li>Features</li>
          <li>Hospitals & Clinics</li>
          <li>Medical Shops & Labs</li>
          <li>About Us</li>
          <li>Contact</li>
        </ul>
      </div>

      {/* Newsletter */}
      <div className="footer-col subscribe-box">
        <h4>Stay Informed</h4>
        <p>Subscribe for doctor tips, wellness news, and MediQNow updates.</p>
        <form className="subscribe-form">
          <input type="email" placeholder="Your email address" />
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="footer-bottom">
      <p>Made with by MediQNow. &copy; {new Date().getFullYear()}</p>
    </div>
  </footer>
  );
}

export default Footer;
